export default __webpack_public_path__ + "static/agent-accounts-dark-fd48a3b7f2f46f20a09abf09bde80d2f.png";